import { SelectBox } from '../../../base/SelectBox';
import { useLookupCollectionType } from '../useLookupCollectionType';

type IComboBoxCollectionTypeProps = {
	name: string;
	value: any;
	valueExpr?: string;
	displayExpr?: string;
	onValueChanged: (value: any) => void;
	label?: string;
	error?: string;
	sizeClass?: 'xs' | 'sm' | 'md' | 'lg';
	helpBlock?: string;
	labelSmall?: boolean;
	isDisabled?: boolean;
	hasValid?: boolean;
	placeholder?: string;
};

const ComboBoxCollectionType = (props: IComboBoxCollectionTypeProps) => {
	const { collection_type_all } = useLookupCollectionType();

	return (
		<SelectBox
			dataSource={collection_type_all}
			valueExpr={'id'}
			displayExpr={'name'}
			{...props}
			placeholder={props.placeholder || 'Chọn danh mục'}
			isClearable={true}
		/>
	);
};
export default ComboBoxCollectionType;